module.exports = __webpack_public_path__ + "media/native-apps/stbirgittaways-94814b49.webp";